import { Inventory, Public, Warehouse } from '@mui/icons-material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { IconButton, Stack, styled } from '@mui/material';
import { DashboardIcon } from 'components/svgIcons/DashboardIcon';
import { StoreIcon } from 'components/svgIcons/StoreIcon';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import {
  isSidebarOpenAtom,
  selectedCategoryDataAtom,
} from 'store/private/layout/layoutAtoms';

export const SidebarActions = props => {
  const navigate = useNavigate();

  const [isSidebarOpen, setIsSidebarOpen] = useAtom(isSidebarOpenAtom);
  const [selectedCategoryData, setSelectedCategoryData] = useAtom(
    selectedCategoryDataAtom,
  );

  return (
    <Stack direction="column" spacing={1}>
      <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
        <MenuRoundedIcon sx={{ color: 'white' }} />
      </IconButton>
      <IconButton
        onClick={() => {
          navigate('/');
          setSelectedCategoryData({
            id: '0',
            name: 'global-settings',
            icon: <Public sx={{ fontSize: 28 }} />,
            label: 'تنظیمات عمومی',
          });
        }}
      >
        <DashboardIcon sx={{ color: 'white' }} />
      </IconButton>
      <IconButton
        onClick={() => {
          setSelectedCategoryData({
            id: selectedCategoryData.id,
            name: 'search',
            icon: <SearchRoundedIcon />,
            label: 'جستجو',
          });
        }}
      >
        <SearchRoundedIcon sx={{ color: 'white' }} />
      </IconButton>
    </Stack>
  );
};
